import { useState, useEffect } from 'react';
import { processVisit } from '../lib/api';
import { haptic } from '../utils/haptic';

interface StreakData {
  streak: number;
  isNewDay: boolean;
}

export function useStreak() {
  const [streakData, setStreakData] = useState<StreakData>({ streak: 0, isNewDay: false });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const result = await processVisit();
        setStreakData({ streak: result.streak, isNewDay: result.is_new_day });
        if (result.is_new_day && result.streak > 1) {
          haptic.success();
        }
      } catch {
        // ignore — streak unavailable without valid token
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { streak: streakData.streak, isNewDay: streakData.isNewDay, loading };
}
